// @flow

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useForm} from 'react-hook-form';
import {Divider, Grid, makeStyles, Typography} from '@material-ui/core';

// import addImage from '../../../../../assets/img/legal/add-image.svg';
import {colors} from '../../../../../assets/styles/colors';

import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
// import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import GuideSizeContent from '../GuideSizeContent/GuideSizeContent';

import type {SizeChart} from '../../duck';
import type {Theme} from '@material-ui/core';
type Props = {
  open: boolean,
  handleClose: () => void,
  chartToEdit?: SizeChart,
};

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    '& .MuiPaper-root': {
      padding: '0px!important',
    },
    '& .MuiAlert-root': {
      padding: '12px!important',
    },
  },
  root: {
    maxWidth: '90%',
    width: 880,
    padding: theme.spacing(4, 1, 2, 1),
    overflowX: 'hidden',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#313135',
  },
  form: {
    width: '100%',
  },
  fieldTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: colors.grey900,
    marginBottom: theme.spacing(2),
  },
  row: {
    margin: theme.spacing(2, 0),
  },
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: `1px solid ${colors.grey300}`,
  },
  buttonsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  buttonLabel: {
    fontSize: 14,
    margin: 0,
  },
  button: {
    padding: theme.spacing(2, 0),
    border: `1px solid ${colors.grey300}`,
    borderRadius: 8,
  },
  buttonSelected: {
    borderColor: colors.purple,
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
    },
  },
  actionButton: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '15rem',
    },
  },
  bgImage: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.grey200,
    margin: theme.spacing(1.5, 0),
  },
  bgImageSelected: {
    backgroundColor: '#EDE4FF',
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));

export default function AddNewSizeGuide(props: Props) {
  const {open, handleClose, chartToEdit} = props;
  const classes = useStyles();

  const {register, trigger, errors, getValues} = useForm({
    mode: 'onBlur',
    shouldUnregister: false,
    defaultValues: {
      sizeGuideName: chartToEdit ? chartToEdit.name : '',
    },
  });

  // const [step, setStep] = useState<number>(0);
  const [guideType] = useState<number>(1);

  // useEffect(() => {
  //   if (chartToEdit) {
  //     console.log('with chart');
  //   }
  // }, [chartToEdit]);

  // const getClassNameSelected = (value: boolean, className: string) =>
  //   value ? className : '';

  // const handleContinueStep = () => {
  //   if (step === 0) {
  //     trigger('sizeGuideName').then(filled => {
  //       if (filled) setStep(1);
  //     });
  //   }
  // };

  const buildFirstStep = () => {
    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.row}>
            <Typography className={classes.fieldTitle}>
              Nombre de guía
            </Typography>

            <CustomTextField
              placeholder="Ej. Guía de tallas"
              name="sizeGuideName"
              inputRef={register({
                required: 'Campo obligatorio',
              })}
              type="text"
              error={!!errors.sizeGuideName}
              helperText={
                errors.sizeGuideName ? errors.sizeGuideName.message : ''
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.row}>
          {/* <Typography className={classes.fieldTitle}>
            Nombre de guía de tallas
          </Typography> */}

          <GuideSizeContent
            trigger={trigger}
            chartToEdit={chartToEdit}
            guideType={guideType}
            setStep={() => {}}
            getValues={getValues}
          />

          {/* <div className={classes.buttonsWrap}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <CustomButton
                  fullWidth
                  onClick={() => setGuideType(1)}
                  className={`${classes.button} ${getClassNameSelected(
                    guideType === 1,
                    classes.buttonSelected
                  )}`}
                >
                  <div className={classes.buttonContent}>
                    <div
                      className={`${classes.bgImage} ${getClassNameSelected(
                        guideType === 1,
                        classes.bgImageSelected
                      )}`}
                    >
                      <img src={addImage} alt="add btn" />
                    </div>
                    <Typography
                      className={`${classes.fieldTitle} ${classes.buttonLabel}`}
                    >
                      Agregar una imagen
                    </Typography>
                  </div>
                </CustomButton>
              </Grid>
            </Grid>
          </div> */}
        </Grid>
        {/* <Divider
          className={classes.divider}
          style={{margin: '48px 0 16px 0'}}
        />

        <div
          className={classes.actionButtons}
          style={{justifyContent: step ? 'space-between' : 'center'}}
        >
          <CustomButton
            className={classes.actionButton}
            variant="contained"
            onClick={handleContinueStep}
          >
            Siguiente
          </CustomButton>
        </div> */}
      </>
    );
  };

  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modal}
    >
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Crear guía de tallas
        </Typography>
        <Divider className={classes.divider} />

        {/* {step === 0 ? (
          buildFirstStep()
        ) : (
          <GuideSizeContent
            chartToEdit={chartToEdit}
            guideType={guideType}
            setStep={setStep}
            getValues={getValues}
          />
        )} */}
        {buildFirstStep()}
        {/* {step === 0 ? (
          buildFirstStep()
        ) : (
          <GuideSizeContent
            trigger={trigger}
            chartToEdit={chartToEdit}
            guideType={guideType}
            setStep={setStep}
            getValues={getValues}
          />
        )} */}
      </div>
    </CustomModal>
  );
}

AddNewSizeGuide.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  chartToEdit: PropTypes.object,
};
